import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main className="container-page flex min-h-[60vh] flex-col items-center justify-center py-20 text-center">
        <p className="font-label text-[11px] tracking-[0.3em] text-accent-700">404 / PAGE MISSING</p>
        <h1 className="mt-4 font-heading text-[32px] font-semibold text-foreground-950 md:text-[52px]">
          这一页不在这本档案里
        </h1>
        <p className="mt-4 max-w-lg text-sm leading-relaxed text-foreground-600">
          链接可能已经变更，或者地址输入有误。你可以回到首页，或者从分类与专题重新进入。
        </p>
        <p className="mt-2 font-label text-[11px] text-foreground-400">{location.pathname}</p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="whitespace-nowrap rounded-md bg-primary-900 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-800"
          >
            返回首页
          </Link>
          <Link
            to="/category/ethics-drama"
            className="whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-800 transition-colors hover:border-accent-400"
          >
            浏览伦理剧情
          </Link>
          <Link
            to="/search"
            className="whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-800 transition-colors hover:border-accent-400"
          >
            站内搜索
          </Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}